<template>
  <div
    id="participantbyposition"
    class="page"
  >
    <div class="subreport-header">
      Participants By Scouting Position
    </div>
    <div class="row">
      <div class="col-12 d-flex">
        <div class="flex-fill">
          At registration, please recored the primary position in which each
          participant is registered with the Boy Scouts of America and enter the
          total number here.
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-4" />
      <div class="col-4 text-center">
        <b>Number of Participants</b>
      </div>
      <div class="col-4 text-center">
        <b>Percentage of Total</b>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-4">
        <b>Cub Scouting</b>
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4">
        Lion Den Leader
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["1"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["1"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Tiger Den Leader
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["2"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["2"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Wolf Den Leader
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["3"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["3"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Bear Den Leader
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["4"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["4"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Webelos Den Leader
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["5"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["5"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Cubmaster
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["6"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["6"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Pack Committee
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["7"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["7"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Other
      </div>
      <div class="col-4 text-center">
        {{
          formatCount(
            reportInfo["8"].ParticipantCount + reportInfo["9"].ParticipantCount
          )
        }}
      </div>
      <div class="col-4 text-center">
        {{
          formatPercent(
            reportInfo["8"].PercentOfTotal + reportInfo["9"].PercentOfTotal
          )
        }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>Scouts BSA</b>
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4">
        Scoutmaster
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["10"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["10"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Assistant Scoutmaster
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["11"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["11"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Troop Committee
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["12"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["12"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Other
      </div>
      <div class="col-4 text-center">
        {{
          formatCount(
            reportInfo["13"].ParticipantCount +
              reportInfo["14"].ParticipantCount +
              reportInfo["15"].ParticipantCount
          )
        }}
      </div>
      <div class="col-4 text-center">
        {{
          formatPercent(
            reportInfo["13"].PercentOfTotal +
              reportInfo["14"].PercentOfTotal +
              reportInfo["15"].PercentOfTotal
          )
        }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>Venturing</b>
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4">
        Crew Advisor
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["16"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["16"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Crew Associate Advisor
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["17"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["17"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Crew Committee
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["18"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["18"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Other
      </div>
      <div class="col-4 text-center">
        {{
          formatCount(
            reportInfo["19"].ParticipantCount +
              reportInfo["20"].ParticipantCount
          )
        }}
      </div>
      <div class="col-4 text-center">
        {{
          formatPercent(
            reportInfo["19"].PercentOfTotal + reportInfo["20"].PercentOfTotal
          )
        }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>Sea Scouts</b>
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4">
        Skipper
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["21"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["21"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Other
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["22"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["22"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>Exploring</b>
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["23"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["23"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>District</b>
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4">
        District Chair
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["24"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["24"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        District Committee
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["25"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["25"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        District Commissioner
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["26"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["26"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Unit Commissioner
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4 pl-4">
        Cub Scouts
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["27"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["27"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4 pl-4">
        Scouts BSA
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["28"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["28"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4 pl-4">
        Venturing
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["29"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["29"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Other
      </div>
      <div class="col-4 text-center">
        {{
          formatCount(
            reportInfo["30"].ParticipantCount +
              reportInfo["31"].ParticipantCount
          )
        }}
      </div>
      <div class="col-4 text-center">
        {{
          formatPercent(
            reportInfo["30"].PercentOfTotal + reportInfo["31"].PercentOfTotal
          )
        }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>Council</b>
      </div>
      <div class="col-4 text-center" />
      <div class="col-4 text-center" />
    </div>
    <div class="row">
      <div class="col-4">
        President
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["32"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["32"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Council Commissioner
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["33"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["33"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Executive Board
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["34"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["34"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        Other
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["35"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["35"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <b>Area</b>
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["36"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["36"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <b>Regional</b>
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["37"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["37"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <b>National Council</b>
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["38"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["38"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4">
        <b>BSA Professional</b>
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["39"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["39"].PercentOfTotal) }}
      </div>
    </div>
    <div
      class="row"
      v-if="reportInfo['40'].ParticipantCount !== 0"
    >
      <div class="col-4">
        <b>Other</b>
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["40"].ParticipantCount) }}
      </div>
      <div class="col-4 text-center">
        {{ formatPercent(reportInfo["40"].PercentOfTotal) }}
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-4">
        Total
      </div>
      <div class="col-4 text-center">
        {{ formatCount(reportInfo["1"].TotalParticipants) }}
      </div>
      <div class="col-4 text-center">
        100 %
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-3">
        Course No.
        <span class="data-field">{{ courseNumber }}</span>
      </div>
      <div class="col-9">
        Course Director _____________________________________________________
      </div>
    </div>
  </div>
</template>

<script>
import reportsApi from '@/services/api/reports.js'

export default {
  name: 'ReportParticipantByPosition',
  data: function () {
    return {
      reportInfo: {
        1: {},
        2: {},
        3: {},
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
        9: {},
        10: {},
        11: {},
        12: {},
        13: {},
        14: {},
        15: {},
        16: {},
        17: {},
        18: {},
        19: {},
        20: {},
        21: {},
        22: {},
        23: {},
        24: {},
        25: {},
        26: {},
        27: {},
        28: {},
        29: {},
        30: {},
        31: {},
        32: {},
        33: {},
        34: {},
        35: {},
        36: {},
        37: {},
        38: {},
        39: {},
        40: {}
      }
    }
  },
  computed: {
    courseNumber: function () {
      return this.$root.courseName
    }
  },
  mounted: function () {
    reportsApi
      .getParticipantsByPositionReport(this.$root.courseKey)
      .then(response => {
        this.reportInfo = response
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    formatCount: function (rawValue) {
      if (rawValue === undefined || rawValue === null || rawValue === 0) {
        return '--'
      } else {
        return rawValue
      }
    },
    formatPercent: function (rawValue) {
      if (rawValue === undefined || rawValue === null || rawValue === 0) {
        return '--'
      } else {
        return rawValue.toFixed(2) + ' %'
      }
    }
  }
}
</script>
